import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useStorage } from '~Components/Storage';

import { useI18n, useSelector } from '~Hooks';
import { StyledH4 } from '~ComponentsImproved/Typography/Heading/styles';
import Modal from '~ComponentsImproved/Modal';
import { SettingsBlock } from '~Scenes/Settings-v2';
import ModalWrapper from '~ComponentsImproved/Modal/ModalWrapper';
import StationIcon from '~Assets/icons/product_table-management.svg';
import { StationSettings } from '~Scenes/Settings-v2/Scenes/KDS/Components/StationSettings';

export const Subtitle = styled(StyledH4)`
  font-size: 16px;
  opacity: 0.7;
  text-align: center;
  color: var(--colorWhite);
  margin: 20px 80px;
`;

const SelectStation: FC = () => {
  const { i18n } = useI18n();
  const stations = useSelector((state) => state.stations);
  const [{ selectedKDSStation }] = useStorage();

  /* Don't show if company has no stations */
  if (!stations || !stations.length) {
    return null;
  }

  /* Don't show if station is NONE */
  if (selectedKDSStation === 'NONE') {
    return null;
  }

  /* Show if stationId is already set or if it can't be found among company stations */
  const showSelectStation =
    !selectedKDSStation || !stations.find((station) => station.id === selectedKDSStation);
  if (!showSelectStation) {
    return null;
  }

  return (
    <Modal isShowing backdropClose={false}>
      <ModalWrapper
        padding="3xl"
        header={{ title: i18n('Settings.Printers.Stations.None'), icon: StationIcon }}>
        <SettingsBlock>
          <StationSettings isKDSOnboarding />
        </SettingsBlock>
      </ModalWrapper>
    </Modal>
  );
};

export default SelectStation;
